import { Component, EventEmitter, Input, Output } from '@angular/core';

interface CardPersonalityData {
  title: string;
  description: string;
  img: string;
}

@Component({
  selector: 'globot-select-personality',
  template: `
    <div class="grid">
      <!--Card defautl desktop-->
      <ng-container *ngIf="!isMobile">
        <!-- <div class="col-12 md:col-3 lg:col-3">
                        <div [ngClass]="selectedCardIndex === 0 ? 'card-active' : 'card'" (click)="selectCard(0)">
                            <div class="col-12 flex justify-content-center mt-4">
                                <img src="/assets/img/config.png" alt="config">
                            </div>
                            <div class="col-12">
                                <h4>Por defecto</h4>
                                <p>Tu asistente responderá
                                    de forma neutra.</p>
                            </div>
                        </div>
                    </div> -->
        <div class="col-12 md:col-4 lg:col-4">
          <div [ngClass]="selectedCardIndex === 1 ? 'card-active' : 'card'" (click)="selectCard(1)">
            <div class="col-12 flex justify-content-center mt-4">
              <img src="/assets/img/emoji_woman.png" alt="professional" />
            </div>
            <div class="col-12">
              <h4>Servicio al cliente</h4>
              <p>Tu asistente será cercano y amigable. Perfecto para todo tipo de negocios.</p>
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div [ngClass]="selectedCardIndex === 2 ? 'card-active' : 'card'" (click)="selectCard(2)">
            <div class="col-12 flex justify-content-center mt-5">
              <img src="/assets/img/emoji_classical.png" alt="professional" />
            </div>
            <div class="col-12">
              <h4>Formal</h4>
              <p>Tu asistente será gentil y preciso. Perfecto para soporte técnico.</p>
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div [ngClass]="selectedCardIndex === 3 ? 'card-active' : 'card'" (click)="selectCard(3)">
            <div class="col-12 flex justify-content-center mt-5">
              <img src="/assets/img/emoji_party.png" alt="professional" />
            </div>
            <div class="col-12">
              <h4>Lúdico</h4>
              <p>Tu asistente será informal y divertido. Dará respuestas creativas e ingeniosas.</p>
            </div>
          </div>
        </div>
      </ng-container>
      <!--Mobile-->
      <ng-container *ngIf="isMobile">
        <div class="col-12" *ngFor="let card of cards; let i = index">
          <div
            class="mobile-card"
            [ngClass]="selectedCardIndex === i + 1 ? 'card-active' : 'card'"
            (click)="selectCard(i + 1)"
          >
            <div class="mobile-card__img">
              <img [src]="card.img" alt="config" height="50" width="60" />
            </div>
            <div class="mobile-card__text">
              <h4>{{ card.title }}</h4>
              <p>{{ card.description }}</p>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  `,
  styleUrls: ['./select-personallity.component.scss'],
})
export class SelectPersonalityComponent {
  @Output() nextEvent = new EventEmitter<void>();
  @Output() backEvent = new EventEmitter<void>();
  @Output() selectCardEvent = new EventEmitter<number>();

  @Input() selectedCardIndex: number = -1;
  @Input() columns: number = 4;

  isMobile: boolean = window.innerWidth < 768;

  // Resto del código...
  cards: CardPersonalityData[] = [
    //{
    //    title: 'Por defecto',
    //    description: 'Tu asistente responderá de forma neutra.',
    //    img: '/assets/img/config.png'
    //},
    {
      title: 'Servicio al cliente',
      description: 'Tu asistente será cordial y amigable. Su principal objetivo será orientar.',
      img: '/assets/img/emoji_woman.png',
    },
    {
      title: 'Formal',
      description: 'Tu asistente será serio y formal. Responderá de manera técnica y precisa.',
      img: '/assets/img/emoji_classical.png',
    },
    {
      title: 'Lúdico',
      description:
        'Tu asistente será relajado y divertido. Puede dar respuestas creativas e ingeniosas.',
      img: '/assets/img/emoji_party.png',
    },
  ];

  selectCard(index: number): void {
    if (this.selectedCardIndex !== index) {
      this.selectedCardIndex = index;
      this.selectCardEvent.emit(this.selectedCardIndex);
    }
  }
}
